import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({
  setConfirmationModal,
  onSuccess,
  onCancel,
  type = '',
}) => {
  const { t } = useTranslation('Order');

  const saveSubmit = async () => {
    onSuccess();
  };
  const handleCancel = async () => {
    onCancel?.();
    setConfirmationModal(false);
  };
  return (
    <div className="modal fade show d-block add-new-fbz" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('CUTOFFTIME')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setConfirmationModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            {type === 'FBZ' ? (
              <h3>{t('CUTOFFMESSAGEFBZ')}</h3>
            ) : (
              <h3>{t('CUTOFFMESSAGE')}</h3>
            )}
            <h2>{t('CUTOFFTIMECONFIRMATION')} </h2>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button className="cancel" onClick={() => handleCancel()}>
                {t('CANCEL')}
              </button>
              <button className="save" onClick={() => saveSubmit()}>
                {t('CONFIRM')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationModal;
